import React, { Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Footer from '../../components/Footer/Footer';

import Dashboard from '../../views/Dashboard/Dashboard';

import Logout from '../../views/Logout/Logout';
import Forbidden from '../../views/Forbidden/Forbidden';
//Devices
import DebugConsol from '../../views/RoomSocket/VMDebugConsol';
//PrivRouter
import PrivateRoute from '../../views/PrivateRoute/PrivateRoute.js';
import SafePrivateRoute from '../../views/PrivateRoute/SafePrivateRoute.js';

import VMS from '../Routes/Devices/DeviceManager/DeviceManager.js';
import CUSTOMERUSERS from '../CustomerUsers/CustomerUsers.js';
import ROOTUSERS from '../RootUsers/RootUsers.js';
import HardwareManagement from '../HardwareManagement/HardwareManagement';
import PartnerManagement from '../PartnerManagement/PartnerManagement';
import USERS from '../Routes/Administration-Partner/Users/Users.js';
import CompanyProfile from '../Routes/Administration-Partner/CompanyProfile/CompanyProfile.js';
import LOGSLIST from '../Logs/Logs.js';
import SALES from '../Sales/Sales.js';
import Notifications from '../../containers/Notifications/Notifications';
import { ToastContainer } from 'react-toastify';

import ProductSalesRoute from '../Routes/Report/ProductSales/ProductSales.js';
import CashFlowRoute from '../Routes/Report/CashFlow/CashFlow.js';
import MediaRoute from '../Routes/Devices/Media/Media.js';
import CustomerListPageRoute from '../Routes/Administration-Partner/CustomerListPage/CustumerListPage.js';
import InvisibleTouchManagerPageRoute from '../Routes/InvisibleTouch/InvisibleTouchManagerPage/InvisibleTouchManager.js';
// import ProductManagerPageRoute from '../ProductManagerPage/ProductManagerPage'
import GroupManagerPageRoute from '../Routes/Devices/GroupManagerPage/GroupManagerPage.js';
import CampaningManagerPageRoute from '../CampaningManagerPage/CampaningManagerPage';
import PromotionManagerPageRoute from '../Routes/InvisibleTouch/PromotionManagerPage/PromotionManagerPage.js';
import NewLogsPageRoute from '../Routes/Report/NewLogsPage/NewLogsPage.js';
import SalesAndIncomePageRoute from '../Routes/Report/SalesAndIncomePage/SalesAndIncomePage.js';
import HardwareRiportRoute from '../Routes/Report/HardwareReport/HardwareReportRoute.js';
import PackageManagerPageRoute from '../Routes/Devices/PackageManagerRoute/PackageManagerRoute.js';
import { connect } from 'react-redux';
import withRouter from '../../services/util/withRouter';

type Props = {
	user: Object | null
};
type States = {};

class Full extends React.Component<Props, States> {
	constructor(props) {
		super(props);
	}

	render() {		
		return (
			<div className="app">
				<ToastContainer
					position="top-right"
					autoClose={5000}
					style={{ zindex: 1999 }}
				/>
				<Header />
				<div className="app-body">
					<Sidebar {...this.props} />
					<main className="main">
						<Container fluid>
							<Routes>
								<Route
									path="/companyprofile/*"
									element={
										<SafePrivateRoute>
											<CompanyProfile />
										</SafePrivateRoute>
									}
								/>

								<Route
									path="/logs/*"
									element={
										<SafePrivateRoute>
											<LOGSLIST />
										</SafePrivateRoute>
									}
								/>

								<Route
									path="/users/*"
									element={
										<SafePrivateRoute>
											<USERS />
										</SafePrivateRoute>
									}
								/>

								<Route
									path="/rootUsers/*"
									element={
										<SafePrivateRoute>
											<ROOTUSERS />
										</SafePrivateRoute>
									}
								/>

								<Route
									path="/hardwareManagement/*"
									element={
										<SafePrivateRoute>
											<HardwareManagement />
										</SafePrivateRoute>
									}
								/>

								<Route
									path="/partnerManagement/*"
									element={
										<SafePrivateRoute>
											<PartnerManagement />
										</SafePrivateRoute>
									}
								/>

								<Route 
									path="/vms/*" 
									element={
										<SafePrivateRoute>
											<VMS />
										</SafePrivateRoute>
									} 
								/>

								<Route
									path="/customerUsers/*"
									element={
										<SafePrivateRoute>
											<CUSTOMERUSERS />
										</SafePrivateRoute>
									}
								/>

								<Route path="/sales/*" element={<SALES />} />

								<Route
									path="/notifications/*"
									element={<Notifications />}
								/>

								<Route
									path="/productSales/*"
									element={<ProductSalesRoute />}
								/>
								<Route
									path="/cashFlow/*"
									element={<CashFlowRoute />}
								/>
								<Route path="/media/*" element={<MediaRoute />} />
								<Route
									path="/costumer_list/*"
									element={<CustomerListPageRoute />}
								/>
								<Route
									path="/invisible_touch_manager/*"
									element={<InvisibleTouchManagerPageRoute />}
								/>
								{/* <Route path="/product_manager/*" element={<ProductManagerPageRoute />} /> */}
								<Route
									path="/group_manager/*"
									element={<GroupManagerPageRoute />}
								/>
								<Route
									path="/campaning_manager/*"
									element={<CampaningManagerPageRoute />}
								/>
								<Route
									path="/promotion_manager/*"
									element={<PromotionManagerPageRoute />}
								/>
								<Route
									path="/newLogs/*"
									element={<NewLogsPageRoute />}
								/>
								<Route
									path="/sales_and_income/*"
									element={<SalesAndIncomePageRoute />}
								/>
								<Route
									path="/hardware_report/*"
									element={<HardwareRiportRoute />}
								/>
								<Route
									path="/package_manager/*"
									element={<PackageManagerPageRoute />}
								/>
								<Route
									path="/vmDebug/*"
									element={
										<SafePrivateRoute>
											<DebugConsol />
										</SafePrivateRoute>
									}
								/>

								<Route 
									path="/dashboard/*" 
									element={
										<PrivateRoute>
											<Dashboard />
										</PrivateRoute>
									} 
								/>

								<Route path="/forbidden" element={<Forbidden />} />

								<Route path="/Logout" element={<Logout />} />

								<Route path="/" element={<Navigate to="/dashboard" replace />} />
							</Routes>
						</Container>
					</main>
				</div>
				<Footer />
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user
});

export default connect(mapStateToProps)(withRouter(Full));
